import { Language } from '@shared/types'
import { getLanguage } from '@ui-common/utils'
import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { MediumSectionContent } from '@ui-components/containers/MediumSectionContent'
import { Divider } from '@ui-components/decorative/Divider'
import { FlexColumnContainer } from '@ui-components/global/CommonStyling'
import { AdditionalText, LabelText } from '@ui-components/typography/Typography'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

const CustomFooterWrapper = styled(FlexColumnContainer)`
  div:first-of-type {
    margin: 1rem 0;
  }
  hr {
    margin: 4rem 0 1rem;
  }
`

export const TheEndFooter = () => {
  const { formatMessage } = useIntl()
  const userLanguage = getLanguage()
  return (
    <CustomFooterWrapper>
      <MediumSectionContent>
        <LabelText sizing="large">
          <FormattedMessage id="loan-offer-the-end-step-see-also-heading" />
        </LabelText>
        {userLanguage === Language.Fi && (
          <ExternalLink
            href={formatMessage({ id: 'loan-offer-the-end-step-buyers-guide-link' })}
            key={'loan-offer-the-end-step-buyers-guide'}
          >
            {formatMessage({ id: 'loan-offer-the-end-step-buyers-guide-text' })}
          </ExternalLink>
        )}
        <ExternalLink
          href={formatMessage({ id: 'loan-offer-the-end-step-fixed-interest-link' })}
          key={'loan-offer-the-end-step-fixed-interest'}
        >
          {formatMessage({ id: 'loan-offer-the-end-step-fixed-interest-text' })}
        </ExternalLink>
      </MediumSectionContent>
      <Divider />
      <MediumSectionContent>
        <AdditionalText>{formatMessage({ id: 'loan-offer-the-end-footer-note' })}</AdditionalText>
      </MediumSectionContent>
    </CustomFooterWrapper>
  )
}
